<template>
  <div
    class="container admin"
    :id="$store.state.app.basics.database+'_admin'"
    style="height: 100%"
    v-if="
      ($store.state.app &&
        $store.state.app.user.indexOf($store.state.auth.uid) > -1) ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.indexOf(
          $store.state.auth.uid
        ) > -1)
    "
  >
    <keep-alive>
      <component
        :id="'iform_' + app.name.norm()"
        :class="'iform_' + app.name.norm()"
        style="height: 100%"
        :is="'iform'"
        :form-model="app"
        searchenabled="true"
      ></component>
    </keep-alive>
  </div>
  <div v-else class="container p8">
    <p>You must be logged in as the app creator to access this admin.</p>
    <login></login>
  </div>
</template>
<script>
export default {
  name: "admin",
  computed: {
    app() {
      return {
        name: "Update App",
        submit: {
          method: "update",
          type: "app",
        },
        forms: [
          {
            name: "basics",
            inputs: [
              {
                inputType: "input",
                label: "database",
                type: "text",
                placeholder: "Database ID",
                default: this.$store.state.app.basics.database,
                disabled: true,
                copy: true
              },
              {
                default: this.$store.state.app.basics.live,
                inputType: "check",
                label: "live",
                placeholder: "Check to make this app live.",
                type: "text",
              },
              ...(this.$store.state.app.basics && !this.$store.state.app.basics.live ? [{
                inputType: "select",
                label: "preview",
                type: "text",
                placeholder: "Select a page to show when site is not live (non-admin users only)",
                options: this.$store.state.app.pages ? Object.keys(this.$store.state.app.pages).map(pageName => ({ name: pageName })) : [],
                default: this.$store.state.app.basics.preview || "",
              }] : []),
              {
                inputType: "items",
                label: "items",
                type: "text",
                placeholder: "Content types",
                default: this.$store.state.app.basics.items || [],
              },
              {
                inputType: "meta",
                label: "meta",
                type: "text",
                placeholder: "Meta",
                default: this.$store.state.app.basics.meta || [],
              },
              {
                inputType: "menus",
                label: "menus",
                type: "text",
                placeholder: "Content types",
                default: this.$store.state.app.basics.menus || {},
              },
              {
                inputType: "file",
                label: "logo",
                type: "image",
                placeholder: "Logo image URL",
                default: this.$store.state.app.basics.logo,
              },
              {
                inputType: "input",
                label: "app name",
                type: "text",
                placeholder: "Name your app",
                default: this.$store.state.app.basics["app name"] || Date.now(),
              },
              {
                inputType: "modules",
                label: "modules",
                type: "text",
                placeholder: "Modules",
                default: this.$store.state.app.basics.modules || [],
              },
              {
                default: this.$store.state.app.basics.export,
                inputType: "button",
                label: "export",
                text: "Save this config.",
                methodtype: "dispatch",
                method: "export",
                payload: {
                  type: "app",
                  data: this.$store.state.app,
                  name: this.$store.state.app.basics["database"],
                },
                type: "button",
                class: "xs-font",
              },
              {
                default: this.$store.state.app.basics.import,
                inputType: "file",
                label: "import",
                placeholder: "Import app config",
                methodtype: "dispatch",
                method: "import",
                type: "json",
                class: "xs-font",
              },
            ],
          },
          {
            name: "payments",
            inputs: [
              {
                inputType: "select",
                label: "payment-types",
                type: "text",
                placeholder: "Select payment types",
                multiple: true,
                options: [
                  { name: "Xymbol" },
                  { name: "PayPal" },
                  { name: "Crypto" },
                  { name: "Credit" }
                ],
                default: this.$store.state.app.payments?.["payment-types"] || [],
              },
              {
                inputType: "input",
                label: "stripe-key",
                type: "password",
                placeholder: "Site-wide Stripe secret key",
                default: "",
              },
            ],
          },
          {
            name: "advanced",
            inputs: [
              {
                inputType: "functions",
                label: "functions",
                type: "text",
                placeholder: "Functions",
                default: this.$store.state.app.advanced.functions || {},
              },
              {
                inputType: "hooks",
                label: "hooks",
                type: "text",
                placeholder: "Hooks",
                default: this.$store.state.app.advanced.hooks || {},
              },
              {
                inputType: "smartcontracts",
                label: "smartcontracts",
                type: "text",
                placeholder: "Smart Contracts",
                default: this.$store.state.app.advanced.smartcontracts || {},
              },
              {
                inputType: "api",
                label: "api",
                type: "text",
                placeholder: "Api",
                default: this.$store.state.app.advanced.api || [],
              },
              {
                inputType: "textarea",
                label: "custom-script",
                type: "text",
                placeholder: "Add custom script to load before app initialization",
                default: this.$store.state.app.advanced["custom-script"] || "",
              }
            ],
          },
          {
            name: "style",
            inputs: [
              {
                inputType: "textarea",
                label: "custom-css",
                type: "text",
                placeholder: "Add custom css properties",
                default: this.$store.state.app.style["custom-css"] || "",
              },
              {
                inputType: "file",
                label: "background-image",
                type: "image",
                placeholder: "Background image url",
                default: this.$store.state.app.style["background-image"],
              },
              {
                inputType: "input",
                label: "background-color",
                type: "color",
                placeholder: "Background color",
                default:
                  this.$store.state.app.style["background-color"] ||
                  "rgb(10,13,11)",
              },
              {
                inputType: "input",
                label: "color",
                type: "color",
                placeholder: "Text and flair colour",
                default: this.$store.state.app.style.color || "#efefef",
              },
              {
                inputType: "input",
                label: "navbar",
                type: "color",
                placeholder: "Choose navigation bar color.",
                default:
                  this.$store.state.app.style.navbar || "rgba(11,15,12,.9)",
              },
              {
                inputType: "input",
                label: "container",
                type: "color",
                placeholder: "Choose container color.",
                default:
                  this.$store.state.app.style.container || "rgba(11,15,12,.9)",
              },
              {
                inputType: "input",
                label: "sub-container",
                type: "color",
                placeholder: "Choose container color.",
                default:
                  this.$store.state.app.style["sub-container"] ||
                  "rgba(11,15,12,.9)",
              },
              {
                inputType: "input",
                label: "button",
                type: "color",
                placeholder: "Choose button color.",
                default:
                  this.$store.state.app.style.button || "",
              },
              {
                inputType: "input",
                label: "success",
                type: "color",
                placeholder: "Choose success/proceed color.",
                default:
                  this.$store.state.app.style.success ||
                  "rgba(27, 199, 99, 0.925)",
              },
              {
                inputType: "input",
                label: "warn",
                type: "color",
                placeholder: "Choose warning color.",
                default:
                  this.$store.state.app.style.warn ||
                  "rgba(226, 123, 179, .925)",
              },
              {
                inputType: "input",
                label: "update",
                type: "color",
                placeholder: "Choose update/save color.",
                default:
                  this.$store.state.app.style.update ||
                  "rgba(25, 143, 221, 0.925)",
              },
              {
                inputType: "input",
                label: "indicate",
                type: "color",
                placeholder: "Choose indication color.",
                default:
                  this.$store.state.app.style.indicate ||
                  "rgba(255, 169, 39, 0.925)",
              },
            ],
          },
          {
            name: "pages",
            description:
              "In-depth copy regarding your legalese, policies, and more content about your purpose.",
            inputs: (() => {
              var retArray = [
                // {
                //   inputType: "file",
                //   label: "homepage image",
                //   type: "image",
                //   placeholder: "Select homepage image",
                //   default: this.$store.state.app.pages["homepage image"] || "",
                //   if: ["homepage", true]
                // }
              ];
              // let components = [
              //   ...Object.values(this.$store.state.components).map(
              //     (comps) => comps
              //   ),
              // ].flat();
              // let pages = [...Object.keys(this.$store.state.app.pages)];

              Object.keys(this.$store.state.app.pages).forEach((pagetitle) => {
                if (
                  this.$store.state.app.pages[pagetitle] &&
                  this.$store.state.app.pages[pagetitle] !== null
                ) {
                  this.$store.state.app.pages[pagetitle].components.map(
                    (comp, compkey) => {
                      if (!comp.props) return;
                      Object.entries(comp.props).map((prop) => {
                        if (
                          prop[1] && 
                          typeof prop[1] === "string" &&
                          prop[1].indexOf("p__") === 0
                        ) {
                          let point = this.$store.state;
                          prop[1]
                            .split("state.")[1]
                            .split(".")
                            .forEach((key) => {
                              point = !+key ? point[key] : point[+key];
                            });
                          this.$store.state.app.pages[pagetitle].components[
                            compkey
                          ].props[prop[0]] = point;
                        }
                      });
                    }
                  );

                  // retArray[1].options.push(pagetitle);
                  retArray.push({
                    inputType: "page",
                    label: pagetitle,
                    type: "page",
                    media: this.$store.state.app.pages[pagetitle].media || {}, // object of type.name.values
                    components:
                      this.$store.state.app.pages[pagetitle].components || [], // object of component.prop.values
                    pages: this.$store.state.app.pages[pagetitle].pages || [], // array of page titles
                    permissions:
                      this.$store.state.app.pages[pagetitle].permissions || {}, // object of roles.type.values
                    routes: this.$store.state.app.pages[pagetitle].routes || {}, // object of routes.query.values
                    // pageoptions: pages,
                    styles: this.$store.state.app.pages[pagetitle].styles || {
                      style: {},
                      classes: "",
                    },
                    // componentoptions: components,
                    placeholder: pagetitle,
                    published:
                      this.$store.state.app.pages[pagetitle].published || true,
                    default: this.$store.state.app.pages
                      ? this.$store.state.app.pages[pagetitle]
                      : {
                          text: "",
                          components: [],
                          pages: [],
                          media: {},
                          styles: { style: {}, classes: "" },
                          published: true,
                        },
                  });
                }
              });
              return this.$_.orderBy(retArray, [
                (page) => page.label.toLowerCase(),
              ]);
            })(),
          },
          {
            name: "users",
            inputs: [
              {
                inputType: "roles",
                label: "roles",
                type: "text",
                placeholder: "Roles",
                default: this.$store.state.app.advanced.roles || {
                  editor: { permissions: {}, requirements: {}, hooks: {} },
                  admin: { permissions: {}, requirements: {}, hooks: {} },
                  user: { permissions: {}, requirements: {}, hooks: {} },
                },
              },
            ],
          },
        ],
      };
    },
    recipes() {
      return {
        jobs: [
          {
            abilities: ["jobs"],
            description: "List jobs for hiring movers",
            forms: [this.basicGroup],
            icon: "fas fa-handshake",
            name: "jobs",
            recipe: "jobs",
            reqModules: [
              "auth",
              "cart",
              "comments",
              "jobs",
              "messages",
              "profiles",
              "notifications",
              "reputation",
            ],
          },
        ],
        events: [
          {
            abilities: ["purchases", "events"],
            description: "List events and sell tickets",
            forms: [this.basicGroup],
            icon: "fas fa-calendar-alt",
            name: "events",
            recipe: "events",
            reqModules: [
              "auth",
              "cart",
              "comments",
              "events",
              "notifications",
              "profiles",
              "reputation",
            ],
          },
        ],
        Blog: [
          {
            abilities: [],
            description: "Post content like articles, images, essays, etc",
            forms: [this.basicGroup],
            icon: "fas fa-pencil-alt",
            name: "blog",
            reqModules: ["comments", "profiles", "reputation"],
          },
        ],
        Products: [
          {
            abilities: ["purchases"],
            description: "Create an online shop to sell products and services",
            forms: [this.basicGroup],
            icon: "far fa-gem",
            name: "products",
            recipe: "products",
            reqModules: [
              "auth",
              "cart",
              "notifications",
              "profiles",
              "reputation",
            ],
          },
        ],
        messages: [
          {
            abilities: [],
            description: "Create an online shop to sell products and services",
            forms: [this.basicGroup],
            icon: "far fa-gem",
            name: "messages",
            reqModules: [
              "auth",
              "notifications",
              "messages",
              "profiles",
              "secrets",
            ],
          },
        ],
      };
    },
    whoIs() {
      return this.$store.dispatch("auth", { type: "currentuser" });
    },
  },
  data() {
    return {
      basicGroup: {
        name: "basics",
        description: "The basic bits of an item.",
        inputs: [
          {
            inputType: "input",
            label: "title",
            type: "text",
            placeholder: "title",
            default: "",
            priority: 1,
            if: []
          },
          {
            inputType: "textarea",
            label: "description",
            type: "text",
            placeholder: "Description",
            default: "",
            priority: 2,
            if: []
          },
          {
            inputType: "file",
            label: "image",
            type: "image",
            placeholder: "Image Url",
            default: "",
            priority: 3,
            if: []
          },
          {
            inputType: "tags",
            label: "tags",
            type: "tags",
            placeholder: "tags",
            default: [],
            priority: 4,
            if: []
          },
          {
            inputType: "check",
            label: "published",
            type: "text",
            placeholder: "Publish this item",
            default: true,
            priority: 4,
            if: []
          },
          {
            inputType: "check",
            label: "bypassTruncation",
            type: "text",
            placeholder: "Bypass text truncation",
            default: false,
            priority: 5,
            if: []
          },
        ],
      },
      show: {
        import: false,
        activateMods: false,
        recipes: false,
      },
      newadmin: "",
    };
  },
  methods: {
    cookRecipe(recipes, recipeName) {
      if (
        this.$store.state.app.basics.items &&
        this.$store.state.app.basics.items.length > 1 &&
        confirm(
          "This will overwrite existing items and download a export config. Proceed?"
        ) === false
      ) {
        return null;
      }
      this.$store.state.app.basics.items &&
      this.$store.state.app.basics.items.length > 1
        ? this.exportapp()
        : void 0;
      this.$set(this.$store.state.app, "recipe", recipeName);
      this.$set(this.$store.state.app.basics, "items", []);
      this.$set(this.$store.state.app, "itemTypes", []);

      recipes.forEach((recipe, recipeKey) => {
        recipe.reqModules.forEach((reqModule) => {
          this.$store.state.app.basics = this.$store.state.app.basics || {};
          this.$store.state.app.basics.modules =
            this.$store.state.app.basics.modules || [];
          if (this.$store.state.app.basics.modules.indexOf(reqModule) < 0) {
            this.$store.state.app.basics.modules.push(reqModule);
          }
        });
        this.$store.state.app.basics.items[recipeKey] = {
          abilities: recipe.abilities,
          name: recipe.name,
          forms: [this.basicGroup],
        };
        recipe.abilities.forEach((ability) => {
          if (
            this.$store.state.app.basics.items[recipeKey].forms.indexOf(
              this.$store.state.abilities[
                this.$store.state.abilityTypes.indexOf(ability)
              ]
            ) < 0
          ) {
            this.$store.state.app.basics.items[recipeKey].forms.push(
              this.$store.state.abilities[
                this.$store.state.abilityTypes.indexOf(ability)
              ]
            );
          }
        });
        this.$store.dispatch("update", {
          type: "app",
          data: this.$store.state.app,
        });
      });
    },
    importapp(name, files) {
      console.log('attempting to import config');
      var reader = new FileReader();
      reader.onload = ((file) => {
        console.log(reader.readAsText(file));
        return (e) => {
          var confirmation = confirm(
            "Import " +
              JSON.parse(e.target.result).basics["app name"] +
              " config? This will overwrite the current app config."
          );
          confirmation && JSON.parse(e.target.result).basics["app name"]
            ? this.$store.dispatch("update", {
                type: "app",
                data: JSON.parse(e.target.result),
              }).then(()=>location.reload())
            : console.log("import rejected");
        };
      })(files[0]);
    },
    exportapp() {
      var exportData = this.$store.state.app;
      delete exportData.database;
      var filename =
        this.$store.state.app.basics["app name"] +
        "-" +
        new Date(Date.now()) +
        ".json";
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," +
          encodeURIComponent(JSON.stringify(exportData))
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
  },
  watch: {
    "this.$store.state.app.pages": {
      handler: function (newval, oldval) {
        if (
          newval &&
          oldval &&
          JSON.stringify(newval) !== JSON.stringify(oldval)
        ) {
          this.app.forms[2].inputs = (() => {
            var retArray = [];
            Object.keys(newval).forEach((pagetitle) => {
              if (newval[pagetitle] && newval[pagetitle] !== null) {
                newval[pagetitle].components.map((comp, compkey) => {
                  if (!comp.props) return;
                  Object.entries(comp.props).map((prop) => {
                    if (
                      prop[1] &&
                      typeof prop[1] === "string" &&
                      prop[1].indexOf("p__") === 0
                    ) {
                      let point = this.$store.state; 
                      prop[1]
                        .split("state.")[1]
                        .split(".")
                        .forEach((key) => {
                          point = !+key ? point[key] : point[+key];
                        });
                      newval[pagetitle].components[compkey].props[
                        prop[0]
                      ] = point;
                      this.$store.commit("setState", {
                        prop: "counter",
                        val: this.$store.state.counter++,
                      });
                    }
                  });
                });

                retArray.push({
                  inputType: "page",
                  label: pagetitle,
                  type: "page",
                  media: newval[pagetitle].media || {}, // object of type.name.values
                  components: newval[pagetitle].components || [], // object of component.prop.values
                  pages: newval[pagetitle].pages || [], // array of page titles
                  permissions: newval[pagetitle].permissions || {}, // object of roles.type.values
                  routes: newval[pagetitle].routes || {}, // object of routes.query.values
                  // pageoptions: pages,
                  styles: newval[pagetitle].styles || {
                    style: {},
                    classes: "",
                  },
                  // componentoptions: components,
                  placeholder: pagetitle,
                  default: newval
                    ? newval[pagetitle]
                    : {
                        text: "",
                        components: [],
                        pages: [],
                        media: {},
                        styles: { style: {}, classes: "" },
                      },
                });
              }
            });
            return this.$_.orderBy(retArray, [
              (page) => page.label.toLowerCase(),
            ]);
          })();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  
};
</script>